<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <treatment-card-input />
    </div>
  </div>
</template>
<script>
import TreatmentCardInput from "@/components/Cards/TreatmentCardInput.vue";

export default {
  components: {
    TreatmentCardInput,
  },
};
</script>
